import {
    ConfigurationParameters,
    Configuration,
    AnnonceLegaleApi,
    AnnoncesLegalesApi,
    PrestationAnnonceLgaleApi,
} from '../../openApi/ApiAnnoncesLegales';

/**
 * Configuration
 */

export function buildAnnonceLegalesRedux(configAl: ConfigurationParameters) {
    const annoncesLegalesConfiguration = new Configuration(configAl);

    const legalAdvertApi = new AnnonceLegaleApi(annoncesLegalesConfiguration);
    const legalsAdvertApi = new AnnoncesLegalesApi(annoncesLegalesConfiguration);
    const legalPrestationsApi = new PrestationAnnonceLgaleApi(annoncesLegalesConfiguration);

    return {
        serviceConfiguration: annoncesLegalesConfiguration,
        serviceConfigurationParameters: configAl,
        apis: {
            legalAdvertApi,
            legalsAdvertApi,
            legalPrestationsApi,
        },
        thunks: {},
        slices: {},
        fetchItems: {},
        getItems: {},
        models: {},
    };
}
